import 'notification';
import 'ng-infinite-scroll';
import './services/index';
import './directives/index';
import 'routes/routes';
import SpinnerSvc from 'services/SpinnerSvc';
import {AuthenticationSvc} from './services/AuthenticationSvc';
import {EventSvc} from './services/EventSvc';
import {ProjectModalSvc} from './services/ProjectModalSvc';
import {TranslateSvc} from './services/TranslateSvc';
import {Utils} from './underscore-extensions';
import {AnalyticSvc} from './services/AnalyticSvc';
import {Strings} from 'Strings';
import {AffiliateSvc} from './services/AffiliateSvc';

interface MyRootScope extends ng.IRootScopeService {
    authSvc: AuthenticationSvc;
    projectModalSvc: ProjectModalSvc;
    TranslateSvc: TranslateSvc;
    animatronProduct: AnimatronProduct;
    stateChangeSuccess: boolean;
}
angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);
angular.module('animatronApp', [
    'oc.lazyLoad',
    'templates',
    'animatronApp.services',
    'animatronApp.directives',
    'cfp.loadingBar',
    'animatronApp.routes',
    'ipCookie',
    'infinite-scroll']
    .concat(window.Raven ? ['ngRaven'] : [])
)
    .config(($anchorScrollProvider: ng.IAnchorScrollProvider,
             $qProvider: any,
             $compileProvider: ng.ICompileProvider,
             $logProvider: ng.ILogProvider,
             $sceDelegateProvider: ng.ISCEDelegateProvider,
             $ocLazyLoadProvider: oc.ILazyLoadProvider,
             $httpProvider: ng.IHttpProvider) => {
        $ocLazyLoadProvider.config({
            // jsLoader() { console.error('use webpack for scripts, pls', arguments);},
            jsLoader: loadScripts,
            loadedModules: ['animatronApp'],
            debug: options.debug,
            events: options.debug
        });
        $qProvider.errorOnUnhandledRejections(options.debug);
        $logProvider.debugEnabled(options.debug);
        ($compileProvider as any)
            .debugInfoEnabled(options.debug)
            .preAssignBindingsEnabled(true)
            .commentDirectivesEnabled(false)
            .cssClassDirectivesEnabled(false);
        $anchorScrollProvider.disableAutoScrolling();
        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            'http://*.animatron.com/**', 'https://*.animatron.com/**',
            'http://*.animatron-test.com/**', 'https://*.animatron-test.com/**',
            'http://d110oqv827o66u.cloudfront.net/**', 'https://d110oqv827o66u.cloudfront.net/**',
            'http://d1nvrnigxcwebn.cloudfront.net/**', 'https://d1nvrnigxcwebn.cloudfront.net/**'
        ]);
        $httpProvider.useApplyAsync(true);
        $httpProvider.interceptors.push(($q, $injector) => {
            let retries             = 0;
            const waitBetweenErrors = 1000;
            const maxRetries        = 10;

            function onResponseError(httpConfig: ng.IRequestConfig) {
                const $http    = $injector.get('$http');
                const $timeout = $injector.get('$timeout');
                console.log('Error loading html, retrying', httpConfig.url);
                return $timeout(() => $http(httpConfig), waitBetweenErrors);
            }

            return {
                responseError(response) {
                    if (response.config && ((/\.html$/.test(response.config.url) || /assets\/html/.test(response.config.url)))) {
                        if (retries < maxRetries) {
                            retries++;
                            return onResponseError(response.config);
                        }
                    }
                    retries = 0;
                    return $q.reject(response);
                }
            } as ng.IHttpInterceptor;
        });
    })
    .run(($rootScope: MyRootScope,
          $state: ng.ui.IStateService,
          $location: ng.ILocationService,
          UserChangeWatcherSvc: any,
          $urlRouter: any,
          ProjectModalSvc: ProjectModalSvc,
          AuthenticationSvc: AuthenticationSvc,
          analyticSvc: AnalyticSvc,
          affiliateSvc: AffiliateSvc,
          ipCookie: any,
          cfpLoadingBar: any,
          EventSvc: EventSvc,
          TranslateSvc: TranslateSvc) => {
        SpinnerSvc.set(cfpLoadingBar);
        EventSvc.init();
        $rootScope.TranslateSvc       = TranslateSvc;
        $rootScope.t                  = TranslateSvc.get.bind(TranslateSvc);
        $rootScope.stateChangeSuccess = false;

        if ($location.search().apiProd) {
            options.apiDomain = '//api.animatron.com';
        } else if ($location.search().apiTest) {
            options.apiDomain = '//api.animatron-test.com';
        }
        //set options passed from Play Framework (in index.scala.html)
        $rootScope.options = options;
        $rootScope.user    = options.user;

        $rootScope.authSvc          = AuthenticationSvc;
        $rootScope.projectModalSvc  = ProjectModalSvc;
        $rootScope.pendingUserEmail = () => ipCookie('_animatron_activate_pending');

        // init affiliates programs
        const affiliateRouteEventOff = $rootScope.$on('$stateChangeSuccess', (ev, s) => {
            affiliateSvc.init();
            affiliateRouteEventOff();
        });

        //don't resolve route(show anything) until user is loaded
        const load = $rootScope.$on('$locationChangeStart', e => {
            e.preventDefault();
            UserChangeWatcherSvc.init(() => {
                $urlRouter.sync();
                TranslateSvc.fetchTranslations();
                $rootScope.$on('$stateChangeStart', () => {
                    SpinnerSvc.show();
                    _.each(document.head.querySelectorAll('[rel=next], [rel=prev]'), el =>
                        el.parentElement.removeChild(el));
                });
                const prerenederStatus = <HTMLMetaElement>document.head.querySelector('[name=prerender-status-code]');
                const robots           = <HTMLMetaElement>document.head.querySelector('[name=robots]');
                $rootScope.$on('$stateChangeSuccess', (ev, s) => {
                    $rootScope.animatronProduct = Utils.getProductByState($state);
                    $rootScope.isWave           = $rootScope.animatronProduct === 'WAVE';
                    $rootScope.isStudio         = $rootScope.animatronProduct === 'STUDIO';
                    analyticSvc.changePage();

                    if (!$rootScope.stateChangeSuccess) {
                        $rootScope.$applyAsync(() => {
                            $rootScope.stateChangeSuccess = true;
                        }); // timeout fix some bug in safari
                    }

                    const faviconEl = <HTMLLinkElement>document.querySelector('[rel="icon"]');
                    faviconEl.href  = $rootScope.isWave ?
                        require('../images/favicon-wave.ico') :
                        require('../images/favicon.ico');

                    if (!_.find([/project-analytics/, /^project$/, /^explore/], r => r.test(s.name))) { //hide loading bar manually for specified states
                        SpinnerSvc.hide();
                    }
                    setTimeout(() => window.scroll(0, 0));
                    prerenederStatus.content = s.httpStatus ? s.httpStatus : '200';
                    robots.content           = s.noindex ? 'noindex' : 'all';

                    const urlTags = document.head.querySelectorAll('[name="twitter:url"], [property="og:url"], [rel="canonical"]');
                    _.each(urlTags, (el: HTMLMetaElement) =>
                        el[el.content ? 'content' : 'href'] = window.location.href.split('%3F')[0].split('?')[0]
                    );
                    if (typeof ga !== 'undefined') {
                        ga('send', 'pageview', $location.path());
                    }
                });
                if (load) load();
            });
        });

        $rootScope.retina   = options.retina;
        $rootScope.handHeld = options.handHeld;

        $rootScope.setTitle = (key, ...param) => {
            const productL        = Utils.getProductByState($state).toLowerCase();
            const productC        = Strings.capitalize(productL);
            const defaultTitleKey = `default.${productL}.title`;
            const product         = productC === 'Any' ? 'Animatron' : productC;

            return TranslateSvc.async(defaultTitleKey).then(defaultTitle => {
                const title = key && TranslateSvc.get(key, ...param);

                if (typeof title === 'string' && title.length > 0) {
                    const suffix = TranslateSvc.get(`${productL}.title.suffix`);
                    _.each(document.head.querySelectorAll('[name="twitter:title"], [property="og:title"]'), el =>
                        (el as any).content = `${title} | ${suffix}`
                    );
                    return $rootScope.title = `${title} | ${suffix}`;
                } else {
                    return $rootScope.title = defaultTitle;
                }
            }).catch(a => console.error(`Missing key for title '${key}'`));
        };
    });




// WEBPACK FOOTER //
// ./app/assets/javascripts/app.ts